/* eslint-disable */
<template>
  <div>
    <b-row>
      <b-col class="row-align-left">
        <label >What is your country of birth?</label>
      </b-col>
    </b-row>
    <b-row>
        <b-col sm="4" lg="3" v-for="country in countries" :key="country.Id">
          <label class="float-left">
          <input
            type="radio"
            class="option-input radio"
            :class="{ 'invalid-radio-button': countryCodeRadioBtnState }"
            name="rd6"
            :value="country.Id"
            v-model="$v.counrtyCodeRadioBtn.$model"
          >
          {{ country.Value }}
        </label>
        </b-col>
        <b-col sm="4">
          <countries-ddl v-show="showCountries" @set-country="setCountryCode" :CountryCodeValue="countryCode" :isValid="countryCodeState"></countries-ddl>
        </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="5">
        <label for>What is the zip code where you live?</label>
      </b-col>
      <b-col sm="2">
        <b-form-input placeholder="zip code" :state="zipCodeState" v-model="$v.zipCode.$model"></b-form-input>
      </b-col>
    </b-row>
    <hr>
    <b-row class="row-align-left">
      <b-col sm="7">
        <label for="radios9">
          Are you a resident of Palm Beach County?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio option-input2"
                :class="{ 'invalid-radio-button': isWpbResidentState }"
                name="rd8"
                value="true"
                v-model="$v.isWpbResident.$model"
              >
              <span class="radText">Yes</span>  
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left">
              <input
                type="radio"
                class="option-input radio option-input2"
                :class="{ 'invalid-radio-button': isWpbResidentState }"
                name="rd8"
                value="false"
                v-model="$v.isWpbResident.$model"
              >
              <span class="radText">No</span>
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <survey-nav :step="5" :ShowErrorMsg="showErrorMsg" @move-next="moveNext" @move-previous="movePrevious"></survey-nav>
  </div>
  
</template>
<script>
import { required } from "vuelidate/lib/validators";
import surveyNav from "@/components/SurveyNav";
import countriesDdl from "@/components/Countries";
import countryCodes from "@/resources/CountryCodes"

export default {
  name: "survey-step5",
  props: ["surveyData", "isValid"],
  
  components: {
    countriesDdl,
    surveyNav
  },
  data: () => ({
    counrtyCodeRadioBtn: null,
    countryCode: null,
    zipCode: null,
    isWpbResident: false,
    countries: [ 
      {Id: "US", Value: "United States"},
      {Id: "CA", Value: "Canada"},
      {Id: "HT", Value: "Haiti"},   
      {Id: "CU", Value: "Cuba"},   
      {Id: "MX", Value: "Mexico"},   
      {Id: "CO", Value: "Colombia"},   
      {Id: "JM", Value: "Jamaica"},   
      {Id: "GT", Value: "Guatemala"},   
      {Id: "HN", Value: "Honduras"},   
      {Id: "PE", Value: "Peru"},   
      {Id: "BR", Value: "Brazil"},   
      {Id: "PR", Value: "Puerto Rico"},   
      {Id: "OTHER", Value: "Other"}
      ],
    showErrorMsg: false
  }),
  validations: {
    counrtyCodeRadioBtn:{
      required
    },
    countryCode: {
      required
    },
    zipCode: {
      required
    },
    isWpbResident: {
      required
    }
  },
  methods: {
    moveNext() {
      if (!this.$v.$invalid) this.$emit("move-next");
      else{
        this.showErrorMsg = true;
        this.$v.$touch();
      } 
    },
     movePrevious() {
      this.$emit("move-previous");
    },
    setCountryCode(event){
      /* We are using the countries dropdown component to allow the user to select an OTHER country, but if they
      *  select a country that is also one of the radio buttons, then we want to select the associated radio button.
      *  To accomplish this, we are using two variables to track the country code.  One for the radio buttons and
      *  another for the drop down. The countryCode data element will hold the final country code selection
       */
      console.log('Setting the country code to: ' + event)
      this.countryCode = event;
      this.surveyData.CountryOfBirth = event;
      let countryIndex = this.countries.findIndex(x => x.Id === this.surveyData.CountryOfBirth);
      console.log("setCountryCode: " + countryIndex);
      if(countryIndex >= 0)
        this.counrtyCodeRadioBtn = this.countries[countryIndex].Id;
    },
    onCreated(){
      //debugger;
      console.log("Country of Birth: " + this.surveyData.CountryOfBirth)
      this.countryCode = this.surveyData.CountryOfBirth;
      let countryIndex = this.countries.findIndex(x => x.Id === this.surveyData.CountryOfBirth);
      console.log("onCreated: " + countryIndex);
      if(countryIndex >= 0)
        this.counrtyCodeRadioBtn = this.countries[countryIndex].Id;
      this.zipCode = this.surveyData.ZipCode;
      this.isWpbResident = this.surveyData.IsWpbResident;
    }
  },  
  computed:{
    //Radio buttons must return a !result
    countryCodeRadioBtnState() {
        console.log('compute country code radio button')
      if( this.$v.counrtyCodeRadioBtn.$dirty){
        console.log('compute country code ddl is dirty')
        if(this.counrtyCodeRadioBtn != null){
          if(this.counrtyCodeRadioBtn.toUpperCase() != "OTHER"){
            this.countryCode = this.counrtyCodeRadioBtn;          
            console.log('compute country code radio button status1 - ' + (!this.$v.countryCode.required));
            return !this.$v.countryCode.required;
          }
          else{          
            console.log('compute country code radio button status2 - false');
            this.countryCode = null;
            return false;
          }
        }
        else{
          //dirty but no data, so it is invalid
          this.countryCode = null;
          return true;
        }
        
      } 
      else{
        return null;
      } 
    },
    countryCodeState() {
      return this.$v.countryCode.$dirty ? this.$v.countryCode.required : null;
    },
    zipCodeState() {
      console.log("compute zip code");
      return this.$v.zipCode.$dirty ? this.$v.zipCode.required : null;
    },    
    showCountries(){
      console.log("show ddl: " + (this.counrtyCodeRadioBtn === "OTHER"));
      return(this.counrtyCodeRadioBtn === "OTHER");
    },
    isWpbResidentState() {
      return this.$v.isWpbResident.$dirty ? !this.$v.isWpbResident.required : null;
    }
  },
  watch: {
    counrtyCodeRadioBtn() {
      console.log("watching country code radio button");
      if (this.$v.counrtyCodeRadioBtn.required) {
        console.log("country code radio button is dirty");
        if(this.counrtyCodeRadioBtn != null && this.counrtyCodeRadioBtn.toUpperCase() != "OTHER"){
          this.surveyData.CountryOfBirth = this.counrtyCodeRadioBtn;
          this.countryCode = this.counrtyCodeRadioBtn;
        }
        else{
          this.surveyData.CountryOfBirth = null;
          this.counrtyCode = null;
          console.log("country code is null");
        }
      }
    },
    countryCode(){      
      console.log("watching country code ddl");
      if (this.$v.countryCode.$dirty) {
        console.log("country code is dirty");
        this.surveyData.CountryOfBirth = this.countryCode;
      }
      if(this.countryCode == null)
        console.log("country code ddl is null");
      else
        console.log("country code ddl: " + this.countryCode);
    },
    zipCode() {
      console.log("watching zip code: " + this.zipCode);
      if (this.$v.zipCode.required) this.surveyData.ZipCode = this.zipCode;
    },
    isWpbResident() {
      if (this.$v.isWpbResident.required) {
        this.surveyData.IsWpbResident = this.isWpbResident;
      }
    }
  },
  created() {
    this.onCreated();
  }
};
</script>
<style>
hr {
    margin-top: 5px; 
    margin-bottom: 5px;
}

.option-input2 {
  top: 5px;
}

.radText {
  margin-bottom: 5px;
}

</style>
